import { ReleaseBanner, useReleaseCheck } from '@provenance/design';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { RELEASE } from './release';

/**
 * Notices a deploy while this tab is open. Shows a Reload notice, and reloads by itself on
 * the next navigation — the moment a fresh page load costs nothing that was on screen.
 */
export function UpdateWatcher() {
  const { outdated, latest } = useReleaseCheck(RELEASE);
  const location = useLocation();
  const first = useRef(true);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    if (outdated) window.location.reload();
    // Only navigation should trigger this, not the moment `outdated` flips.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return outdated ? <ReleaseBanner latest={latest} /> : null;
}
